import { createContext, useCallback, useMemo, useState } from 'react'

export const FiltersContext = createContext(null)

export const FiltersProvider = ({ children }) => {
  const initialFilters = {
    categoryType: [],
    countryCoverage: [],
    countryCoverageCode: [],
    search: '',
  }

  const [filter, setFilter] = useState(initialFilters)

  const handleSetFilter = useCallback((name: string, value: string) => {
    setFilter((prev) => {
      return {
        ...prev,
        [name]: value,
      }
    })
  }, [])

  const handleResetFilters = useCallback(() => {
    setFilter(initialFilters)
  }, [])

  const values = useMemo(() => {
    return {
      filter,
      handleResetFilters,
      handleSetFilter,
    }
  }, [filter, handleResetFilters, handleSetFilter])

  return (
    <FiltersContext.Provider value={values}>{children}</FiltersContext.Provider>
  )
}
